<template lang="pug">
  .blindbox
    .blindbox-cover(@click="onClose")
    .blindbox-body
      .blindbox-buy
        dl.blindbox-buy-qrcode2
          dt
            img(src="~assets/footprint/img-qrcode.png")
          dd {{qrcode}}
          //- canvas(id="blindboxQrcodeCanvas")
        dl.blindbox-buy-desc
          dt 恭喜您已解锁限定盲盒购买资格！
          dd 您可以前往微笑商店，通过刷脸支付23元，<br/>随机获得下方图鉴中的一项奖品。
      .blindbox-guide
        .blindbox-guide-title 盲盒系列图鉴
        .blindbox-guide-item(v-for="(item, i) in guide" :key="i" :class="'blindbox-guide-item-' + (i + 1)")
          dl.blindbox-guide-item-desc
            dt {{item.title}}
            dd {{item.desc}}
          .blindbox-guide-item-index 0{{i + 1}}
          dl.blindbox-guide-item-price
            dt 价值
            dd ¥{{item.price}}
        .blindbox-guide-tip *购买盲盒时请出示资格码，每人当天仅可购买一次
  </template>
  <script>
  import QRCode from 'qrcode'
  export default {
    name: 'Tip',
    props: {
      qrcode: String,
    },
    data() {
      return {
        guide: [
          { title: '走到哪都挂住你', desc: '蚂蚁森林可爱摆挂件', price: 28, },
          { title: '一位靓仔好有型', desc: '蚂蚁与森林公仔', price: 39, },
          { title: '今天也是正能量', desc: '能量精选伴手礼', price: 64, },
          { title: '守护你的少女心', desc: '蚂蚁毛绒玩具', price: 158, },
          { title: '欧皇惊喜大满贯', desc: '蚂蚁森林能量福袋', price: 325, },
        ],
      }
    },
    watch: {
      // qrcode(val, oldVal) {
      //   if (val && !oldVal) {
      //     this.createQrcode(val);
      //   }
      // },
    },
    computed: {},
    methods: {
      onClose() {
        this.$emit('close')
      },
      // createQrcode(val) {
      //   var canvas = document.getElementById('blindboxQrcodeCanvas');
      //   QRCode.toCanvas(canvas, val, function (error) {
      //     if (error) console.error(error)
      //     console.log('success!');
      //   })
      // }
    },
    mounted() {
      // if (this.qrcode) {
      //   this.createQrcode(this.qrcode);
      // }
    }
  }
  </script>
  
  <style scoped lang="sass">
  @import "src/styles/common"
  @import "src/styles/footprint"
  .blindbox
    +full; z-index: 9999; position: fixed
  .blindbox-cover
    +full; background: rgba(0, 0, 0, 0.55)
  .blindbox-body
    position: absolute; top: 16%; bottom: 0; left: 0; width: 100%; overflow-y: auto
    background: url("~assets/footprint/bg-body.png") top center repeat
    background-size: pxRes(414);
    &:before
      +full; content: ''
      background: url("~assets/space/popup-bg.png") top center no-repeat
      background-size: pxRes(414);
    &:after
      position: absolute; top: pxRes(17); left: 50%; margin: 0 0 0 pxRes(-33); width: pxRes(66)
      height: pxRes(4.5); border-radius: pxRes(2.5); background: #CCCCCC; content: ''
  .blindbox-buy
    position: relative; margin: pxRes(64) pxRes(23) 0; background: #FFFFFF;
    box-shadow: 0px pxRes(4) pxRes(10) rgba(0, 0, 0, 0.1);
    border-radius: pxRes(10);text-align: center;
    .blindbox-buy-qrcode2
      margin: 0
    .blindbox-buy-qrcode2 dt
      padding: pxRes(40) 0 0
      width: pxRes(125)
      margin: 0 auto
      img
        +image
    .blindbox-buy-qrcode2 dd
      +text(60, 40); text-align: center;font-family: DIN Alternate; font-style: normal; font-weight: bold;
      margin: 0;
      padding: pxRes(34) 0 0
    .blindbox-buy-qrcode
      padding: pxRes(66) 0 0
      img, canvas
       width: pxRes(190); height: pxRes(190)
    dl.blindbox-buy-desc
      padding: pxRes(48) 0 0; margin: 0
      dt
        +text(16, 22); color: #333333
      dd
        +text(14, 20); color: #999999; margin: 0; padding: 0 0 pxRes(66)
  .blindbox-guide
    padding: pxRes(44) pxRes(23)
    .blindbox-guide-title
      +text(20, 28); color: #1677FF;
    .blindbox-guide-item
      background-color: #FFFFFF; box-shadow: 0px -1px pxRes(10) rgba(226, 226, 226, 0.7); border-radius: pxRes(10);
      height: pxRes(165); position: relative; margin: 0 0 pxRes(16)
      background-repeat: no-repeat
      dl.blindbox-guide-item-desc
        position: absolute; left: pxRes(30); top: pxRes(30); margin: 0
        dt
          +text(20, 28); color: #333333
        dd
          +text(12, 17); color: #999999; margin: 0
      .blindbox-guide-item-index
        position: absolute; left: pxRes(30); bottom: pxRes(17); margin: 0
        font-family: 'DIN Alternate';
        +text(50, 58); color: rgba(51, 51, 51, 0.06);
      dl.blindbox-guide-item-price
        position: absolute; right: pxRes(33); top: pxRes(12); margin: 0
        width: pxRes(55); height: pxRes(55)
        background: url("~assets/footprint/bg-blindbox-price.png") top center no-repeat
        background-size: pxRes(55); text-align: center
        dt
          +text(5, 7); color: #333333; padding: pxRes(16) 0 0
        dd
          +text(15, 15); color: #333333; margin: 0
    .blindbox-guide-item-1
      background-image: url("~assets/footprint/bg-blindbox-1.png");
      background-position: pxRes(166) pxRes(30);
      background-size: pxRes(165.5)
    .blindbox-guide-item-2
      background-image: url("~assets/footprint/bg-blindbox-2.png");
      background-position: pxRes(188) pxRes(23);
      background-size: pxRes(275/2)
    .blindbox-guide-item-3
      background-image: url("~assets/footprint/bg-blindbox-3.png");
      background-position: pxRes(163) pxRes(37);
      background-size: pxRes(374/2)
    .blindbox-guide-item-4
      background-image: url("~assets/footprint/bg-blindbox-4.png");
      background-position: pxRes(161) pxRes(31);
      background-size: pxRes(338/2)
    .blindbox-guide-item-5
      background-image: url("~assets/footprint/bg-blindbox-5.png");
      background-position: pxRes(166) pxRes(29);
      background-size: pxRes(331/2)
    .blindbox-guide-tip
      +text(14, 20); color: #999999; margin: 0
  </style>
  